export const ETAT_RECEPTIONNE = 'Receptionne';
export const ETAT_PRISE_EN_CHARGE = 'PriseEnCharge';
export const ETAT_EXPEDIE = 'Expedie';
export const ETAT_LIVREE = 'Livree';
export const ETAT_POSE = 'Pose';
export const ETAT_ACTION_COMMERCIALE = 'EnAttenteActionCommerciale';
export const ETAT_PERSONNALISATION_MAQUETTE = 'PersonnalisationMaquette';

export const ACTION_MASS_CREATION_EDITION_OT = 'MassCreationEditionOT';
export const ACTION_MASS_CREATION_DEMANDE_IMPRESSION = 'MassCreationDemandeImpression';

export const COULEUR_BLANC = 'Blanc';
export const COULEUR_ROSE = 'Rose';
export const COULEUR_JAUNE = 'Jaune';
export const COULEUR_BLEU = 'Bleu';

export const COULEUR_IMPRESSION = [
  {
    key: COULEUR_BLANC, libelle: 'editionDemandeImpression.couleurImpression.blanc', icon: 'checkbox-blank-circle', type: 'has-text-white',
  },
  {
    key: COULEUR_JAUNE, libelle: 'editionDemandeImpression.couleurImpression.jaune', icon: 'checkbox-blank-circle', type: 'has-text-warning',
  },
  {
    key: COULEUR_ROSE, libelle: 'editionDemandeImpression.couleurImpression.rose', icon: 'checkbox-blank-circle', type: 'has-text-colorLogistique',
  },
  {
    key: COULEUR_BLEU, libelle: 'editionDemandeImpression.couleurImpression.bleu', icon: 'checkbox-blank-circle', type: 'has-text-primary',
  },
];

export const ETAT_DEMANDE_IMPRESSION = [
  {
    key: ETAT_RECEPTIONNE, libelle: 'editionDemandeImpression.etatDemandeImpression.receptionne',
  },
  {
    key: ETAT_PRISE_EN_CHARGE, libelle: 'editionDemandeImpression.etatDemandeImpression.transmisPourImpression',
  },
  {
    key: ETAT_EXPEDIE, libelle: 'editionDemandeImpression.etatDemandeImpression.expedie',
  },
  {
    key: ETAT_LIVREE, libelle: 'editionDemandeImpression.etatDemandeImpression.livree',
  },
  {
    key: ETAT_POSE, libelle: 'editionDemandeImpression.etatDemandeImpression.imprimee',
  },
  {
    key: ETAT_ACTION_COMMERCIALE, libelle: 'editionDemandeImpression.etatDemandeImpression.EnAttenteActionCommerciale',
  },
  {
    key: ETAT_PERSONNALISATION_MAQUETTE, libelle: 'editionDemandeImpression.etatDemandeImpression.personnalisationMaquette',
  },
];

export const ACTION_UPDATE_CAMPAGNE = 'UpdateCampgneAll';
export const ACTION_UPDATE_ETAT = 'UpdateEtatAll';
export const ACTION_UPDATE_NOM_FICHIER_RIP = 'UpdateNomFichierRipAll';
export const ACTION_UPDATE_GRAPHISTE = 'UpdateNomGraphisteAll';
export const ACTION_UPDATE_DATE = 'UpdateDateAll';
export const ACTION_UPDATE_QUANTITE = 'UpdateQuantiteAll';

export const COULEUR_ETAT_DEMANDE_IMPRESSION = [
  {
    key: ETAT_RECEPTIONNE, type: 'has-text-colorVert', backgroundColor: 'has-background-colorVert', textClass: 'has-text-black',
  },
  {
    key: ETAT_ACTION_COMMERCIALE, type: 'has-text-colorOrange', backgroundColor: 'has-background-colorOrange', textClass: 'has-text-black',
  },
  {
    key: ETAT_POSE, type: 'has-text-colorBleu', backgroundColor: 'has-background-colorBleu', textClass: 'has-text-white',
  },
  {
    key: ETAT_PERSONNALISATION_MAQUETTE, type: 'has-text-colorRouge', backgroundColor: 'has-background-colorRouge', textClass: 'has-text-white',
  },
  {
    key: ETAT_PRISE_EN_CHARGE, type: 'has-text-colorMauve', backgroundColor: 'has-background-colorMauve', textClass: 'has-text-black',
  },
  {
    key: ETAT_EXPEDIE, type: 'has-text-colorBleuClair', backgroundColor: 'has-background-colorBleuClair', textClass: 'has-text-black',
  },
  {
    key: ETAT_LIVREE, type: 'has-text-colorBleuFonce', backgroundColor: 'has-background-colorBleuFonce', textClass: 'has-text-white',
  },
];

export const ROUTE_ALLOWED_WITHOUT_CLEAN_STORE_FOR_CAMPAGNE = ['c.logistique.demande_impression', 'm.logistique.demande_impression-edit', 'm.logistique.demande_impression-add'];
